/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Commission_Empty_Customers_TitleInputs */



/**
* | output |
* | --- |
* | "No attributed customers yet" |
*
* @param {Partner_Commission_Empty_Customers_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_commission_empty_customers_title = /** @type {((inputs?: Partner_Commission_Empty_Customers_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Commission_Empty_Customers_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine zugeordneten Kunden")
	return /** @type {LocalizedString} */ ("No attributed customers yet")
});